module.exports = __webpack_public_path__ + "static/media/whatsapp.3947fea3.svg";